// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comprovacao-container .header {
  display: flex;
  justify-content: center;
  align-items: center;
}
.comprovacao-container .header h1 {
  font-size: 24px;
}

.example-full-width {
  width: 100%;
}

.buttons {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
}
.buttons .btn-back {
  width: 8rem !important;
}
.buttons a {
  text-decoration: none;
  color: #ae0f0a;
  margin-left: 32px;
}

::ng-deep.mat-mdc-text-field-wrapper {
  background: white;
}

@media (max-width: 1054px) {
  h1 {
    font-size: 24px !important;
  }
  .header {
    flex-direction: column-reverse;
    margin-top: 40px;
  }
}
.dialog-actions {
  margin-top: 16px;
  margin-bottom: 8px;
}

.buttons {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
}
.buttons .btn-back {
  width: 8rem !important;
}
.buttons a {
  text-decoration: none;
  color: #ae0f0a;
  margin-left: 32px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header h1 {
  font-size: 32px;
  color: rgba(0, 0, 0, 0.8705882353);
}

@media (max-width: 1054px) {
  h1 {
    font-size: 24px !important;
  }
  .header {
    margin-top: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/modals/modal-view-relatorioo-vinculados/modal-view-relatorioo-vinculados.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AACI;EACE,eAAA;AACN;;AAGA;EACI,WAAA;AAAJ;;AAEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACF;AAAE;EACE,sBAAA;AAEJ;AAAE;EACE,qBAAA;EACA,cAAA;EACA,iBAAA;AAEJ;;AACA;EACE,iBAAA;AAEF;;AAAA;EACE;IACE,0BAAA;EAGF;EAAA;IACE,8BAAA;IACA,gBAAA;EAEF;AACF;AAAA;EACE,gBAAA;EACA,kBAAA;AAEF;;AAAA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAGF;AAFE;EACE,sBAAA;AAIJ;AAFE;EACE,qBAAA;EACA,cAAA;EACA,iBAAA;AAIJ;;AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAGF;AAFE;EACE,eAAA;EACA,kCAAA;AAIJ;;AAAA;EACE;IACE,0BAAA;EAGF;EADA;IACE,gBAAA;EAGF;AACF","sourcesContent":[".comprovacao-container {\n  .header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    h1 {\n      font-size: 24px;\n    }\n  }\n}\n.example-full-width{\n    width: 100%;\n}\n.buttons {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 32px;\n  .btn-back {\n    width: 8rem !important;\n  }\n  a {\n    text-decoration: none;\n    color: #ae0f0a;\n    margin-left: 32px;\n  }\n}\n::ng-deep.mat-mdc-text-field-wrapper {\n  background: white;\n}\n@media (max-width: 1054px) {\n  h1 {\n    font-size: 24px !important;\n  }\n \n  .header {\n    flex-direction: column-reverse;\n    margin-top: 40px;\n  }\n}\n.dialog-actions {\n  margin-top: 16px;\n  margin-bottom: 8px;\n}\n.buttons {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 32px;\n  .btn-back {\n    width: 8rem !important;\n  }\n  a {\n    text-decoration: none;\n    color: #ae0f0a;\n    margin-left: 32px;\n  }\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  h1 {\n    font-size: 32px;\n    color: #000000DE;\n  }\n \n}\n@media (max-width: 1054px) {\n  h1 {\n    font-size: 24px !important;\n  }\n  .header {\n    margin-top: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
